import { defaultLanguage, defaultLocations, Language, languages, locations } from '../consts';
import { buildLocale } from './build-locale';

export const extractLocaleFromPath = (path: string[]) => {
  const language = extractLanguageFromPath(path);
  const location = extractLocationFromPath(path);
  return buildLocale(language, location);
};

/*
  Extract the language and location from the path array.
  Returns undefined if not found
*/
export const extractLanguageFromPath = (path: string[], langs = languages, includeDefault = false): Language => {
  const firstPart = path[0];
  const lang = firstPart?.split('-')[0]?.toLowerCase() as Language;
  if (!langs.some(l => l.lang === lang)) return includeDefault ? defaultLanguage : undefined;
  return lang;
};

/*
  Extract the location from the path array.
  Returns undefined if not found
*/
const extractLocationFromPath = (path: string[], langs = languages, includeDefault = false): string => {
  const language = extractLanguageFromPath(path, langs, includeDefault);
  if (!language) return;
  const firstPart = path[0];
  const languageLocations = locations[language] as readonly string[];
  const location = firstPart?.split('-')[1]?.toLowerCase();
  if (!location || !languageLocations.includes(location)) {
    return includeDefault ? defaultLocations[language] : undefined;
  }
  return location;
};

/*
  Get the language from the path, falling back to the default if not found.
*/
export const getPathLanguage = (path: string[], langs = languages) => {
  return extractLanguageFromPath(path, langs, true);
};

/*
  Get the location from the path, falling back to the default if not found.
*/
export const getPathLocation = (path: string[], langs = languages) => {
  return extractLocationFromPath(path, langs, true);
};
